import React from 'react';
import { Typography } from '@mui/material';

const Borrowers: React.FC = () => {
  return (
    <div>
      <Typography variant="h4" component="h1" gutterBottom>
        Borrowers Management
      </Typography>
      <Typography variant="body1">
        Borrower management functionality will be implemented here.
      </Typography>
    </div>
  );
};

export default Borrowers;